import { render } from "./Gambling.vue?vue&type=template&id=3ca17d1d"
import script from "./Gambling.vue?vue&type=script&lang=js"
export * from "./Gambling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__